import { createSlice } from '@reduxjs/toolkit';

import { fetchReviewFormConfig, postNewReview, updateReview } from './actions';

import type { ReviewFormConfigState } from './types';

const initialState: ReviewFormConfigState = {
  isFetching: false,
  formConfig: {
    provider: {
      id: '',
      name: '',
    },
    reservation: {
      providerId: '',
      checkInDate: '',
      checkOutDate: '',
      item: { id: '', name: '' },
      plan: undefined,
    },
    profile: undefined,
    scores: [],
    questions: [],
    review: undefined,
  },
  error: undefined,
  isUploading: false,
};

const ReviewConfigSlice = createSlice({
  name: 'reviewConfig',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // review list
      .addCase(fetchReviewFormConfig.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(fetchReviewFormConfig.fulfilled, (state, action) => {
        state.formConfig = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchReviewFormConfig.rejected, (state, action) => {
        state.error = {
          code: action.error.code ?? '',
          message: action.error.message ?? 'Failed to fetch',
        };
        state.isFetching = false;
      })
      // post review
      .addCase(postNewReview.pending, (state) => {
        state.isUploading = true;
      })
      .addCase(postNewReview.fulfilled, (state) => {
        state.isUploading = false;
      })
      .addCase(postNewReview.rejected, (state, action) => {
        state.error = {
          code: action.error.code ?? '',
          message: action.error.message ?? 'Failed to post',
        };
        state.isUploading = false;
      })
      // edit review
      .addCase(updateReview.pending, (state) => {
        state.isUploading = true;
      })
      .addCase(updateReview.fulfilled, (state) => {
        state.isUploading = false;
      })
      .addCase(updateReview.rejected, (state, action) => {
        state.error = {
          code: action.error.code ?? '',
          message: action.error.message ?? 'Failed to edit',
        };
        state.isUploading = false;
      });
  },
});

export const reviewConfigReducer = ReviewConfigSlice.reducer;
